import React, { Component } from 'react';
import PropTypes from 'prop-types';
import User from 'helper/currentUser';
import handleLogout from 'helper/handleLogout';
import ConditionalLoader from 'components/ConditionalLoader';
import { evaluateFeatureFlag } from './helper';

const user = new User();

class FeatureFlagInit extends Component {
  static childContextTypes = {
    getFeatureFlag: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      initialized: false,
      featureFlags: {}
    };

    const { userCheck = true } = props;
    const userId = user.id();

    if (userCheck && !userId) {
      handleLogout('no_user_found');
    }
  }

  getChildContext() {
    return {
      getFeatureFlag: this.getFeatureFlag
    };
  }

  async componentDidMount() {
    const response = await fetch(
      'https://dndw32r4edmw5.cloudfront.net/assets/frontend-js/feature-flags/flags-22-02-rev1.json'
    );
    const data = await response.json();
    window.__getFeatureFlagFunc = this.getFeatureFlag;
    this.setState({
      initialized: true,
      featureFlags: data
    });
  }

  getFeatureFlag = flag => {
    const { featureFlags } = this.state;
    const featureFlag = featureFlags[flag];

    return evaluateFeatureFlag({ featureFlag });
  };

  render() {
    const { initialized } = this.state;
    const { children } = this.props;
    return (
      <ConditionalLoader loading={!initialized} fullScreen={true} mode="dark">
        {children}
      </ConditionalLoader>
    );
  }
}

export default FeatureFlagInit;
